import { useLocale } from "../../../../hooks/useLocale";
import { msg } from "../../../../locales/translate";
import { VBox } from "@ui/box/Box";
import { Activity, Calculator, CalendarDays, CreditCard, FileText, Gauge, Receipt, Store, Undo2, Users } from "lucide-react";
import { Spinner } from "@ui/spinner/Spinner";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { checkFeature } from "src/Featuresmap";
import { IClient } from "src/services/ClientService";
import { SectionId } from "src/utils/SectionId";
import { MerchantGroups } from "src/view/conponents/list/MerchantsGroups";
import { Sessions } from "src/view/forms/Sessions";
import { ReportsTab } from "src/view/pages/reports/ReportsTab";
import { StatementsTab } from "src/view/pages/reports/StatementsTab";
import { ClientInfoForm } from "./ClientInfoForm";
import { ClientPageEvents } from "./ClientPageEvents";
import { ClientPageSummary } from "./ClientPageSummary";
import { ClientPageUsers } from "./ClientPageUsers";
import { ClientChargebacks } from "./ClientChargebacks";
import { GD } from "src/GD";
import { hasAnyRole, hasPermission } from "src/permissions";
import { ClientAccountantView } from "./ClientAccountantView";

export interface IClientPageContentProps {
	client?: IClient;
	hideTitle?: boolean;
	//onClientReady?: (client: IClient) => void;
	onSectionChange?: (section?: SectionId) => void;
}

export const ClientPageContent = ({ client, onSectionChange }: IClientPageContentProps) => {
	useLocale();
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);
	const userProject = project && user ? user.projects.find(val => val.id === project.id) : undefined;
	const canViewReports = hasPermission(userProject?.roles, "reports.view");
	const canViewStatements = hasPermission(userProject?.roles, "statements.view");
	const canViewAccountant = hasAnyRole(userProject?.roles, ["admin", "accountant", "merchant"]);

	//let showAdminControls: boolean = false;
	let hideAppicationTab: boolean = true;
	if (userProject) {
		hideAppicationTab = !hasPermission(userProject.roles, "clients.view_application");
	}
	//!TODO: сделать через настройки проекта, а не по ролям и айдишникам
	if (project && project.id === 3) {
		hideAppicationTab = true;
	}

	return (
		<VBox sx={{ flex: 1, flexGrow: 1 }}>
			{!client && <Spinner />}
			{client && (
				<VBox sx={{ minHeight: "0px", flexGrow: 1 }}>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as any)} onSectionSelect={s => onSectionChange && onSectionChange(s)}>
						<TabItem title={msg("overview")} section={SectionId.CLIENT_OVERVIEW} icon={<Gauge size={16} />}>
							<ClientPageSummary client={client} />
						</TabItem>

						{canViewAccountant && (
							<TabItem title={msg("accountant")} section={SectionId.CLIENT_ACCOUNTANT} icon={<Calculator size={16} />}>
								<ClientAccountantView key={client.id} client={client} />
							</TabItem>
						)}

						{/* <TabItem title="Client Profile" section={SectionId.CLIENT_AML}>
							<Spacer size="20px" />
							<Box>Client Profile</Box>
						</TabItem> */}

						{/* <TabItem title="AML/CTF" section={SectionId.CLIENT_WEBSITES}>
							<ClientPageAML client={client} />
						</TabItem> */}

						{/* <TabItem title="Documents" section={SectionId.CLIENT_FILES}>
							<Files target_id={client.id} target_type="client" />
						</TabItem> */}

						{/* <TabItem title="Services Validation" section={SectionId.CLIENT_SERVICES_VALIDATION}>
							<Spacer size="20px" />
							<Box>Services Validation</Box>
						</TabItem> */}

						{/* <TabItem title="Monitoring" section={SectionId.CLIENT_SERVICES_VALIDATION}>
							<Spacer size="20px" />
							<Box>Monitoring</Box>
						</TabItem> */}

						{/* <TabItem title="Audit Log" section={SectionId.CLIENT_SERVICES_VALIDATION}>
							<Spacer size="20px" />
							<Box>Audit Log</Box>
						</TabItem> */}

						<TabItem title={msg("payments")} section={SectionId.CLIENT_SESSIONS} icon={<CreditCard size={16} />}>
							<Sessions key={client.id} target_id={client.id} target_type="client" filterAppearance="portfolio" />
						</TabItem>

						<TabItem title={msg("chargebacks_655ad8a5")} section={SectionId.CLIENT_CHARGEBACKS} icon={<Undo2 size={16} />}>
							<ClientChargebacks key={`chargebacks-${client.id}`} clientID={client.id} />
						</TabItem>

						<TabItem title={msg("merchants")} section={SectionId.CLIENT_WEBSITES} icon={<Store size={16} />}>
							<MerchantGroups key={client.id} client_id={client.id} client_user_id={client.user_id} internal={false} />
						</TabItem>

						{project && !hideAppicationTab && (
							<TabItem title={msg("application")} icon={<FileText size={16} />}>
								<ClientInfoForm key={client.id} clientID={client.id} />
							</TabItem>
						)}

						{canViewReports && (
							<TabItem title={msg("reports")} icon={<CalendarDays size={16} />}>
								<ReportsTab key={`reports-${client.id}`} clientID={client.id} />
							</TabItem>
						)}

						{canViewStatements && (
							<TabItem title={msg("statements")} icon={<Receipt size={16} />}>
								<StatementsTab key={`statements-${client.id}`} clientID={client.id} />
							</TabItem>
						)}
						<TabItem title={msg("users")} section={SectionId.CLIENT_USERS} icon={<Users size={16} />}>
							<ClientPageUsers key={client.id} client={client} />
						</TabItem>

						<TabItem title={msg("events")} section={SectionId.CLIENT_EVENTS} icon={<Activity size={16} />}>
							<ClientPageEvents key={client.id} client={client} />
						</TabItem>

						{/* <TabItem title="WEBSITES request">
							<WebsitesRequests />
						</TabItem> */}

						{/* <TabItem title="INFO">
							<Info key="info" target_id={client.id} target_type="client" data_type="info" />
						</TabItem> */}

						{/* <TabItem title="Settings" section={SectionId.CLIENT_SETTINGS}>
							<Settings target_id={client.id} target_type="client" />
						</TabItem> */}
					</Tabs>
				</VBox>
			)}
		</VBox>
	);
};
